import { render, staticRenderFns } from "./dataTablecSon.vue?vue&type=template&id=51b5443a&scoped=true&"
import script from "./dataTablecSon.vue?vue&type=script&lang=js&"
export * from "./dataTablecSon.vue?vue&type=script&lang=js&"
import style0 from "./dataTablecSon.vue?vue&type=style&index=0&id=51b5443a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b5443a",
  null
  
)

export default component.exports